import { Pipe, PipeTransform } from "@angular/core";
import { CampaingService } from "../../providers/campaing.service";
import { Observable } from "rxjs/Observable";
import { of } from "rxjs/observable/of";

@Pipe({
  name: "campaing"
})
export class CampaingPipe implements PipeTransform {

  constructor(
    private campaingData: CampaingService
  ) { }

  transform(campaingId: string, stats: boolean): Observable<any> {
    if (campaingId) {
      return this.campaingData.detailCampaing(campaingId, stats);
    }
    return of(true);
  }
}



// WEBPACK FOOTER //
// ./src/pipes/campaing/campaing.ts